import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Copyright from '../Copyright';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  CONST_BUSINESS_MAIL,
  CONST_BUSINESS_NAME,
  CONST_SITE_LABEL
} from '../Helper';
import { Button, Grid, Stack } from '@mui/material';
import { ChatbotChild } from './ChatbotChild.';
import DebugService from '../../../services/DebugService';
import { CONST_ROUTE_PATH } from '../../../route/RouteConstants';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { FaYoutube, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showChatbot, setShowChatbot] = useState(true);
  const [ShowAppointmentBookingSection, setShowAppointmentBookingSection] = useState(true);

  useEffect(() => {
    DebugService.log(`Current pathname ${location.pathname}`)

    const isShowChatOption = ![
      CONST_ROUTE_PATH.QUERY_LOGS,
      CONST_ROUTE_PATH.TERMS_CONDITIONS,
      CONST_ROUTE_PATH.PRIVACY_POLICY,
      CONST_ROUTE_PATH.REFUND_POLICY,
    ].includes(location.pathname);
    setShowChatbot(isShowChatOption);

    const isShowAppointmentBookingSection = ![
      CONST_ROUTE_PATH.QUERY_LOGS,
      CONST_ROUTE_PATH.TERMS_CONDITIONS,
      CONST_ROUTE_PATH.PRIVACY_POLICY,
      CONST_ROUTE_PATH.REFUND_POLICY,
      CONST_ROUTE_PATH.DEMO_CONFIRMED,
    ].includes(location.pathname);
    setShowAppointmentBookingSection(isShowAppointmentBookingSection);
  }, [location.pathname]);

  return (
    <>
      {showChatbot && <ChatbotChild style={{}} />}

      <div className='footer' style={{ background: '#ffffff' }}>
        {ShowAppointmentBookingSection && (
          <div style={{
            background: 'linear-gradient(90deg, #073562 0%, #0c69c6 60%, #02a1e9 100%)',
            padding: '50px 20px',
            textAlign: 'center',
            color: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <Typography 
              variant='caption' 
              style={{ 
                color: '#ffffff', 
                letterSpacing: '0.15em', 
                fontWeight: 600, 
                textTransform: 'uppercase', 
                marginBottom: '12px',
                fontSize: '12px',
                display: 'block',
                opacity: 0.9
              }}
            >
              Start Free Trial
            </Typography>
            <Typography 
              variant='h4' 
              fontWeight={'700'} 
              style={{ 
                marginBottom: '16px', 
                fontFamily: 'inherit',
                fontSize: 'clamp(24px, 3.5vw, 36px)',
                lineHeight: 1.3,
                color: '#ffffff'
              }}
            >
              Want Better <br /> Cloud Visibility & Control?
            </Typography>
            <Typography 
              variant='body2' 
              style={{ 
                color: '#e2e8f0', 
                maxWidth: '650px', 
                margin: '0 auto 28px', 
                opacity: 0.9, 
                lineHeight: 1.6,
                fontSize: '15px'
              }}
            >
              See your global inventory, schedule stop/start for VMs, RDS and Auto Scaling groups, and delegate access by tag — all in one platform.
            </Typography>

            <Stack direction="row" spacing={2} justifyContent="center" style={{ marginBottom: '8px' }}>
              <Button 
                onClick={() => navigate(CONST_ROUTE_PATH.SIGN_UP)}
                variant="contained"
                startIcon={<PlayArrowIcon />}
                style={{
                  backgroundColor: '#ffffff',
                  color: '#073562',
                  fontWeight: 600,
                  textTransform: 'none',
                  padding: '12px 28px',
                  borderRadius: '6px',
                  boxShadow: 'none',
                  fontSize: '15px'
                }}
              >
                Start Free Trial
              </Button>
              <Button 
                onClick={() => navigate(CONST_ROUTE_PATH.SCHEDULE_MEETING)}
                variant="outlined"
                startIcon={<CalendarTodayIcon />}
                style={{
                  color: '#ffffff',
                  borderColor: 'rgba(255, 255, 255, 0.4)',
                  borderWidth: '1px',
                  fontWeight: 600,
                  textTransform: 'none',
                  padding: '12px 28px',
                  borderRadius: '6px',
                  fontSize: '15px',
                  '&:hover': {
                    borderColor: '#ffffff',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)'
                  }
                }}
              >
                Book a Demo
              </Button>
            </Stack>

            <Typography 
              variant='caption' 
              style={{ 
                color: '#ffffff', 
                display: 'block', 
                marginTop: '16px', 
                opacity: 0.8,
                fontSize: '12px'
              }}
            >
              7-day free trial &nbsp;·&nbsp; No credit card required &nbsp;·&nbsp; 100% cloud-based &nbsp;·&nbsp; Set up in minutes
            </Typography>
          </div>
        )}

        {/* Footer Links */}
        <Grid container spacing={4} className='footer-container' style={{ padding: '60px 8vw 30px', background: '#ffffff', color: '#1a202c' }}>

          <Grid item xs={12} md={3} style={{ textAlign: 'left' }}>
            <div>
              <img src={`/CloudsAnalytics-logo-black.png`} alt={CONST_BUSINESS_NAME} style={{ width: '150px', marginBottom: '15px' }} />
            </div>
            <Typography variant='body2' style={{ color: '#4a5568', marginBottom: '15px', maxWidth: '280px', lineHeight: 1.6 }}>
              Cloud visibility, scheduling and access control — one platform for the people who run your cloud.
            </Typography>
            <Typography variant='body2' style={{ color: '#4a5568', marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
              <img src='/email-icon.svg' alt={'Email Address'} width={'20'} height={'20'} style={{ marginRight: '8px', filter: 'invert(0.3)' }} />
              support@cloudsanalytics.ai
            </Typography>
            <div className='footer-social-links' style={{ display: 'flex', gap: '10px', marginTop: '15px', justifyContent: 'flex-start' }}>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" style={{ 
                width: '36px', height: '36px', borderRadius: '50%', background: '#ff0000', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', textDecoration: 'none', transition: 'all 0.2s' 
              }}>
                <FaYoutube size={16} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" style={{ 
                width: '36px', height: '36px', borderRadius: '50%', background: '#1877f2', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', textDecoration: 'none', transition: 'all 0.2s' 
              }}>
                <FaFacebookF size={14} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" style={{ 
                width: '36px', height: '36px', borderRadius: '50%', background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', textDecoration: 'none', transition: 'all 0.2s' 
              }}>
                <FaInstagram size={16} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={{ 
                width: '36px', height: '36px', borderRadius: '50%', background: '#0077b5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', textDecoration: 'none', transition: 'all 0.2s' 
              }}>
                <FaLinkedinIn size={14} />
              </a>
            </div>
          </Grid>

          <Grid item xs={6} sm={3} md={2} style={{ textAlign: 'left' }}>
            <Typography variant='body2' style={{ marginBottom: '15px', color: '#1a202c', fontWeight: '600' }}>Capabilities</Typography>
            <div className='footer-menu' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <Link to={CONST_ROUTE_PATH.DASHBOARD} style={{ color: '#4a5568', textDecoration: 'none' }}>Global Inventory</Link>
              <Link to={CONST_ROUTE_PATH.DASHBOARD} style={{ color: '#4a5568', textDecoration: 'none' }}>Resource Scheduler</Link>
              <Link to={CONST_ROUTE_PATH.DASHBOARD} style={{ color: '#4a5568', textDecoration: 'none' }}>Access Control</Link>
              <Link to={CONST_ROUTE_PATH.DASHBOARD} style={{ color: '#4a5568', textDecoration: 'none' }}>Optimization</Link>
              <Link to={CONST_ROUTE_PATH.DASHBOARD} style={{ color: '#4a5568', textDecoration: 'none' }}>Cost Analytics</Link>
              <Link to={CONST_ROUTE_PATH.DASHBOARD} style={{ color: '#4a5568', textDecoration: 'none' }}>Security Insights</Link>
            </div>
          </Grid>

          <Grid item xs={6} sm={3} md={2} style={{ textAlign: 'left' }}>
            <Typography variant='body2' style={{ marginBottom: '15px', color: '#1a202c', fontWeight: '600' }}>Platform</Typography>
            <div className='footer-menu' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <a href="https://www.cloudsanalytics.ai/#how-it-works" style={{ color: '#4a5568', textDecoration: 'none' }}>How it works</a>
              <Link to={CONST_ROUTE_PATH.PRICING} style={{ color: '#4a5568', textDecoration: 'none' }}>Pricing</Link>
              <a href="https://status.cloudsanalytics.ai" style={{ color: '#4a5568', textDecoration: 'none' }} target="_blank" rel="noreferrer">
                Status <span style={{ backgroundColor: '#22c55e', color: '#ffffff', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', marginLeft: '5px', fontWeight: 600 }}>Operational</span>
              </a>
            </div>
          </Grid>

          <Grid item xs={6} sm={3} md={2} style={{ textAlign: 'left' }}>
            <Typography variant='body2' style={{ marginBottom: '15px', color: '#1a202c', fontWeight: '600' }}>Company</Typography>
            <div className='footer-menu' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <Link to={CONST_ROUTE_PATH.ABOUT} style={{ color: '#4a5568', textDecoration: 'none' }}>About Us</Link>
              <Link to={CONST_ROUTE_PATH.ABOUT} style={{ color: '#4a5568', textDecoration: 'none' }}>Blog</Link>
              <Link to={CONST_ROUTE_PATH.ABOUT} style={{ color: '#4a5568', textDecoration: 'none' }}>Security & Compliance</Link>
              <Link to={CONST_ROUTE_PATH.ABOUT} style={{ color: '#4a5568', textDecoration: 'none' }}>FAQ</Link>
            </div>
          </Grid>

          <Grid item xs={6} sm={3} md={3} style={{ textAlign: 'left' }}>
            <Typography variant='body2' style={{ marginBottom: '15px', color: '#1a202c', fontWeight: '600' }}>Contact</Typography>
            <div className='footer-menu' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <Link to={CONST_ROUTE_PATH.CONTACT_US} style={{ color: '#4a5568', textDecoration: 'none' }}>Contact Us</Link>
              <Link to={CONST_ROUTE_PATH.SCHEDULE_MEETING} style={{ color: '#4a5568', textDecoration: 'none' }}>Schedule Demo</Link>
              <span style={{ color: '#4a5568', cursor: 'pointer' }}>Live Chat</span>
            </div>
          </Grid>

        </Grid>

        {/* Footer copyright */}
        <div className='footer-copyright' style={{ borderTop: '1px solid #e2e8f0', background: '#ffffff', padding: '20px 8vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Copyright style={{ textAlign: 'left', margin: 0 }} color="#4a5568" />
          <div style={{ display: 'flex', gap: '20px' }}>
            <Link to={CONST_ROUTE_PATH.TERMS_CONDITIONS} style={{ color: '#4a5568', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</Link>
            <Link to={CONST_ROUTE_PATH.PRIVACY_POLICY} style={{ color: '#4a5568', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
